import React, { useEffect, useState } from "react";
import ExcelJS from "exceljs";
import AdminNavbar from "../Layout/AdminNavbar";
import ManagerNavbar from "../Layout/ManagerNavbar";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import axios from "axios";
import { toast } from "react-toastify";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";
import { endOfWeek, format, startOfWeek } from "date-fns";

const workPerformanceRatings = [
  { label: "Quality", key: "quality", icon: "◈" },
  { label: "Team Work", key: "teamwork", icon: "⬡" },
  { label: "Initiative", key: "initiative", icon: "↑" },
  { label: "Learning", key: "learning", icon: "◎" },
];

const professionalismRatings = [
  { label: "Attendance", key: "attendance", icon: "📅" },
  { label: "Punctuality", key: "punctuality", icon: "⏰" },
  { label: "Communication", key: "communication", icon: "💬" },
  { label: "Attitude", key: "attitude", icon: "🙂" },
  { label: "Accountability", key: "accountability", icon: "🛡️" },
];

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.55)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1050,
    padding: "16px",
  },
  modal: {
    background: "#ffffff",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "780px",
    maxHeight: "92vh",
    overflowY: "hidden",
    boxShadow: "0 32px 64px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    padding: "22px 28px 18px",
    borderBottom: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    background: "#fff",
    zIndex: 2,
    borderRadius: "20px 20px 0 0",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIconWrap: {
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#0f172a",
    lineHeight: 1.2,
    fontFamily: "inherit",
  },
  headerSub: {
    fontSize: "12px",
    color: "#94a3b8",
    marginTop: "2px",
    fontFamily: "inherit",
  },
  closeBtn: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "#64748b",
    transition: "all 0.15s",
    lineHeight: 1,
  },
  body: {
    padding: "24px 28px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
  },
  twoCol: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  card: {
    background: "#f8fafc",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "18px",
  },
  sectionLabel: {
    fontSize: "10.5px",
    fontWeight: "700",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#94a3b8",
    marginBottom: "14px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  fieldRow: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  fieldLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    fontFamily: "inherit",
  },
  readonlyField: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "9px 13px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontFamily: "inherit",
  },
  select: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "9px 13px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
    width: "100%",
    cursor: "pointer",
    outline: "none",
    fontFamily: "inherit",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='%2394a3b8' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    paddingRight: "32px",
  },
  input: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "9px 13px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#0f172a",
    width: "100%",
    outline: "none",
    fontFamily: "inherit",
  },
  avatarCircle: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    fontWeight: "700",
    color: "#fff",
    flexShrink: 0,
    fontFamily: "inherit",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px",
  },
  statCell: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "11px 13px",
  },
  statLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "3px",
    fontFamily: "inherit",
  },
  statVal: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },
  statInput: {
    border: "none",
    background: "transparent",
    outline: "none",
    fontWeight: "700",
    fontSize: "15px",
    color: "#0f172a",
    width: "100%",
    fontFamily: "inherit",
    padding: 0,
  },
  completedBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    background: "#dcfce7",
    color: "#166534",
    fontSize: "10px",
    fontWeight: "700",
    padding: "2px 7px",
    borderRadius: "999px",
    fontFamily: "inherit",
  },
  ratingsCard: {
    background: "#f8fafc",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "18px",
  },
  ratingRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 13px",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "11px",
    marginBottom: "8px",
    transition: "border-color 0.15s, box-shadow 0.15s",
    cursor: "default",
  },
  ratingLabel: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#334155",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontFamily: "inherit",
  },
  ratingIcon: {
    width: "24px",
    height: "24px",
    borderRadius: "7px",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    color: "#475569",
    flexShrink: 0,
  },
  starsWrap: {
    display: "flex",
    gap: "3px",
  },
  scoreCard: {
    background: "transparent",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "20px 22px",
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  scoreLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },
  scoreNum: {
    fontSize: "36px",
    fontWeight: "800",
    color: "#fff",
    lineHeight: 1,
    fontFamily: "inherit",
  },
  scoreDenom: {
    fontSize: "12px",
    color: "#64748b",
    fontFamily: "inherit",
  },
  scoreRight: {
    flex: 1,
  },
  gradeBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "4px 13px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "700",
    marginBottom: "10px",
    fontFamily: "inherit",
  },
  progressTrack: {
    background: "#f1f5f9",
    borderRadius: "999px",
    height: "6px",
    overflow: "hidden",
    marginBottom: "5px",
  },
  progressFill: {
    height: "100%",
    borderRadius: "999px",
    transition: "width 0.4s ease",
  },
  progressLabels: {
    display: "flex",
    justifyContent: "space-between",
  },
  progressLabel: {
    fontSize: "10px",
    color: "#94a3b8",
    fontFamily: "inherit",
  },
  scoreRingWrap: {
    position: "relative",
    width: "80px",
    height: "80px",
    flexShrink: 0,
  },
  scoreRingInner: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  remarksCard: {
    background: "#f8fafc",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    padding: "18px",
  },
  textarea: {
    width: "100%",
    minHeight: "80px",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    padding: "11px 13px",
    fontSize: "13px",
    color: "#0f172a",
    resize: "vertical",
    outline: "none",
    fontFamily: "inherit",
    lineHeight: 1.6,
    transition: "border-color 0.15s",
  },
  footer: {
    padding: "16px 28px",
    borderTop: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    background: "#fff",
    borderRadius: "0 0 20px 20px",
  },
  footerNote: {
    fontSize: "12px",
    color: "#94a3b8",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontFamily: "inherit",
  },
  btnGroup: {
    display: "flex",
    gap: "8px",
  },
  btnGhost: {
    padding: "9px 20px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    background: "transparent",
    fontSize: "13px",
    fontWeight: "600",
    color: "#64748b",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "all 0.15s",
  },
  btnPrimary: {
    padding: "9px 22px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    fontSize: "13px",
    fontWeight: "700",
    color: "#fff",
    cursor: "pointer",
    fontFamily: "inherit",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    boxShadow: "0 4px 14px rgba(59,130,246,0.4)",
    transition: "all 0.15s",
  },
};

function getInitials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

function getPersonFilterKey(id, name) {
  if (id !== null && id !== undefined && String(id).trim() !== "") {
    return `id:${String(id)}`;
  }
  if (name && String(name).trim() !== "") {
    return `name:${String(name).trim()}`;
  }
  return "";
}

function StarRating({ value = 0, onChange }) {
  const [hovered, setHovered] = useState(0);

  return (
    <div style={styles.starsWrap}>
      {[1, 2, 3, 4, 5].map((star) => {
        const active = star <= (hovered || value);
        return (
          <span
            key={star}
            onClick={() => onChange(star)}
            onMouseEnter={() => setHovered(star)}
            onMouseLeave={() => setHovered(0)}
            style={{
              fontSize: "20px",
              cursor: "pointer",
              color: active ? "#f59e0b" : "#cbd5e1",
              transition: "color 0.12s, transform 0.1s",
              transform: hovered === star ? "scale(1.25)" : "scale(1)",
              display: "inline-block",
              lineHeight: 1,
            }}
          >
            ★
          </span>
        );
      })}
    </div>
  );
}

function ScoreRing({ score, maxScore = 100, ringColor }) {
  const size = 80;
  const strokeWidth = 7;
  const radius = (size - strokeWidth) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = score > 0 ? score / maxScore : 0;
  const offset = circ * (1 - pct);

  return (
    <div style={styles.scoreRingWrap}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e2e8f0"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={ringColor || "#3b82f6"}
          strokeWidth={strokeWidth}
          strokeDasharray={circ.toFixed(2)}
          strokeDashoffset={offset.toFixed(2)}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <div style={styles.scoreRingInner}>
        <span style={{ fontSize: "18px", fontWeight: "800", color: "#0f172a", lineHeight: 1 }}>
          {score > 0 ? Number(score).toFixed(1) : "—"}
        </span>
        <span style={{ fontSize: "10px", color: "#64748b" }}>/ {maxScore}</span>
      </div>
    </div>
  );
}

function getGradeMeta(grade) {
  if (grade === "Excellent")
    return { bg: "#dcfce7", color: "#166534", ringColor: "#22c55e", barColor: "#22c55e" };
  if (grade === "Very Good")
    return { bg: "#dbeafe", color: "#1e40af", ringColor: "#3b82f6", barColor: "#3b82f6" };
  if (grade === "Good")
    return { bg: "#fef9c3", color: "#854d0e", ringColor: "#eab308", barColor: "#eab308" };
  if (grade === "Average")
    return { bg: "#ffedd5", color: "#9a3412", ringColor: "#f97316", barColor: "#f97316" };
  return { bg: "#fee2e2", color: "#991b1b", ringColor: "#ef4444", barColor: "#ef4444" };
}

const EmployeeEvaluation = () => {

  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const activeRole = localStorage.getItem("activeRole");
  const Navbar = activeRole === "ROLE_MANAGER" ? ManagerNavbar
    : activeRole === "ROLE_USER" ? EmployeeNavbar
      : AdminNavbar;

  const [hasAccess, setHasAccess] = useState(null);
  const [evaluations, setEvaluations] = useState([]);
  const [employeeOfMonth, setEmployeeOfMonth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showEvaluationModal, setShowEvaluationModal] = useState(false);
  const [evaluationData, setEvaluationData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("");
  const [selectedYear, setSelectedYear] = useState(format(new Date(), "yyyy"));
  const [selectedEmployeeFilter, setSelectedEmployeeFilter] = useState("");
  const [selectedManagerFilter, setSelectedManagerFilter] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [editingCell, setEditingCell] = useState(null); // { id, field }
  const [cellDraft, setCellDraft] = useState("");
  const [employeeOfYear, setEmployeeOfYear] = useState(null);
  const fetchIdRef = React.useRef(0);
  const employeeOfMonthFetchIdRef = React.useRef(0);
  const employeeOfYearFetchIdRef = React.useRef(0);
  const canLoadEvaluationData = hasAccess === true;

  // ================= PERMISSION CHECK =================
  useEffect(() => {
    if (activeRole === "ROLE_ADMIN") { setHasAccess(true); return; }
    const employeeId = localStorage.getItem("employeeId");
    axios.get(`${API_BASE_URL}/api/permissions/${employeeId}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      setHasAccess(res.data?.pages?.employee_evaluation === true);
    }).catch(() => setHasAccess(false));
  }, []);

  const handleExportExcel = async () => {
    if (!canLoadEvaluationData) return;
    try {
      const params = { month: selectedMonth };
      if (selectedWeek) params.week = selectedWeek;

      const res = await axios.get(`${API_BASE_URL}/api/evaluations`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(res.data) ? res.data : [];
      const filteredData = data.filter((item) => {
        const employeeKey = getPersonFilterKey(item.employeeId, item.employeeName);
        const managerKey = getPersonFilterKey(item.managerId, item.managerName);
        const employeeMatch = !selectedEmployeeFilter || employeeKey === selectedEmployeeFilter;
        const managerMatch = !selectedManagerFilter || managerKey === selectedManagerFilter;
        return employeeMatch && managerMatch;
      });

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Evaluations");

      // ── helpers ──────────────────────────────────────────────────
      const headerFont = { bold: true, size: 10, color: { argb: "FFFFFFFF" } };
      const subFont = { bold: true, size: 9, color: { argb: "FFFFFFFF" } };
      const bodyFont = { size: 9 };
      const center = { horizontal: "center", vertical: "middle", wrapText: true };
      const left = { horizontal: "left", vertical: "middle" };

      const fill = (argb) => ({ type: "pattern", pattern: "solid", fgColor: { argb } });
      const border = () => ({
        top: { style: "thin", color: { argb: "FFE2E8F0" } },
        bottom: { style: "thin", color: { argb: "FFE2E8F0" } },
        left: { style: "thin", color: { argb: "FFE2E8F0" } },
        right: { style: "thin", color: { argb: "FFE2E8F0" } },
      });
      const scoreColor = (val, max) => {
        if (!max) return "FF94A3B8";
        const p = val / max;
        if (p >= 0.8) return "FF16A34A";
        if (p >= 0.5) return "FFCA8A04";
        return "FFDC2626";
      };
      const finalColor = (score) => {
        if (score >= 80) return "FF16A34A";
        if (score >= 60) return "FFF59E0B";
        return "FFEF4444";
      };

      // ── Row 1: group headers ──────────────────────────────────────
      // Columns: 1-Sr, 2-Emp, 3-Reporter, 4-Type, 5-Period,
      //          6-15 Work Performance (9 cols), 16-20 Professionalism (5 cols),
      //          21-Score, 22-Grade, 23-Remarks
      const r1 = sheet.getRow(1);
      r1.height = 28;

      const applyGroupHeader = (cell, text, fgArgb) => {
        cell.value = text;
        cell.font = { ...headerFont };
        cell.fill = fill(fgArgb);
        cell.alignment = center;
        cell.border = border();
      };

      // Frozen columns — span 2 rows
      ["Sr No", "Employee", "Reporter", "Type", "Period"].forEach((label, i) => {
        const cell = r1.getCell(i + 1);
        applyGroupHeader(cell, label, "FF475569");
        sheet.mergeCells(1, i + 1, 2, i + 1);
      });

      // Work Performance group header (cols 6–14)
      applyGroupHeader(r1.getCell(6), "⚡ Work Performance", "FF1D4ED8");
      sheet.mergeCells(1, 6, 1, 14);

      // Professionalism group header (cols 15–19)
      applyGroupHeader(r1.getCell(15), "🤝 Professionalism", "FF5B21B6");
      sheet.mergeCells(1, 15, 1, 19);

      // Summary headers — span 2 rows
      ["Score", "Grade", "Remarks"].forEach((label, i) => {
        const cell = r1.getCell(20 + i);
        applyGroupHeader(cell, label, "FF065F46");
        sheet.mergeCells(1, 20 + i, 2, 20 + i);
      });

      // ── Row 2: sub-headers ────────────────────────────────────────
      const r2 = sheet.getRow(2);
      r2.height = 22;

      const workSubs = ["C / A", "Task /20", "Quality /10", "Teamwork /5", "Initiative /5", "Learning /10", "Bill Hrs", "Avail Hrs", "Bill /20"];
      const profSubs = ["Attend /10", "Punct /5", "Comm /5", "Attitude /5", "Account /5"];

      workSubs.forEach((label, i) => {
        const cell = r2.getCell(6 + i);
        cell.value = label;
        cell.font = { ...subFont };
        cell.fill = fill("FF1E40AF");
        cell.alignment = center;
        cell.border = border();
      });
      profSubs.forEach((label, i) => {
        const cell = r2.getCell(15 + i);
        cell.value = label;
        cell.font = { ...subFont };
        cell.fill = fill("FF4C1D95");
        cell.alignment = center;
        cell.border = border();
      });

      // ── Column widths ─────────────────────────────────────────────
      const widths = [6, 20, 18, 11, 22, 9, 10, 10, 10, 10, 10, 10, 9, 9, 10, 10, 8, 8, 8, 10, 10, 10, 22];
      widths.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });

      // ── Determine winners (same logic as UI) ──────────────────────
      let employeeOfMonthId = null;
      let starOfWeekId = null;

      if (!selectedWeek && filteredData.length) {
        const monthWinnerRes = await axios.get(`${API_BASE_URL}/api/evaluations/employee-of-month`, {
          params: { month: selectedMonth },
          headers: { Authorization: `Bearer ${token}` },
        });
        employeeOfMonthId = monthWinnerRes?.data?.highlightEvaluationId || null;
      } else if (selectedWeek && filteredData.length) {
        starOfWeekId = filteredData.reduce((best, ev) => (ev.finalScore ?? 0) > (best.finalScore ?? 0) ? ev : best).id;
      }

      const winnerId = employeeOfMonthId || starOfWeekId;
      const sorted = winnerId
        ? [...filteredData].sort((a, b) => (a.id === winnerId ? -1 : b.id === winnerId ? 1 : 0))
        : filteredData;

      // ── Data rows ─────────────────────────────────────────────────
      sorted.forEach((e, index) => {
        const isMonth = e.id === employeeOfMonthId;
        const isWeek = e.id === starOfWeekId;
        const rowFill = isMonth ? "FFFFFBEB" : isWeek ? "FFFAF5FF" : index % 2 === 0 ? "FFFFFFFF" : "FFF8FAFF";

        const taskScore = e.assignedTasks > 0 ? (e.completedTasks / e.assignedTasks) * 20 : 0;
        const billScore = e.availableHours > 0 ? (e.billingHours / e.availableHours) * 20 : 0;

        const empLabel = (isMonth ? "🏆 " : isWeek ? "⭐ " : "") + (e.employeeName || e.employeeId || "");

        const values = [
          index + 1,
          empLabel,
          e.managerName || "",
          e.employeeType || "",
          e.month + (e.week ? `\n${e.week}` : ""),
          `${e.completedTasks || 0} / ${e.assignedTasks || 0}`,
          +taskScore.toFixed(1),
          (e.quality || 0) * 2,
          (e.teamwork || 0) * 1,
          (e.initiative || 0) * 1,
          (e.learning || 0) * 2,
          e.billingHours ?? 0,
          e.availableHours ?? 0,
          +billScore.toFixed(1),
          (e.attendance || 0) * 2,
          (e.punctuality || 0) * 1,
          (e.communication || 0) * 1,
          (e.attitude || 0) * 1,
          (e.accountability || 0) * 1,
          e.finalScore ?? 0,
          e.grade || "",
          e.remarks || "",
        ];

        // score color column indices (0-based): taskScore=6, quality=7, teamwork=8, initiative=9, learning=10, billScore=13, attend=14, punct=15, comm=16, att=17, account=18, final=19
        const scoreMax = [null, null, null, null, null, null, 20, 10, 5, 5, 10, null, null, 20, 10, 5, 5, 5, 5, 100, null, null];

        const row = sheet.addRow(values);
        row.height = 20;

        row.eachCell({ includeEmpty: true }, (cell, colNum) => {
          cell.font = { ...bodyFont };
          cell.fill = fill(rowFill);
          cell.border = border();
          cell.alignment = colNum <= 2 ? left : colNum === 5 ? { ...center, wrapText: true } : center;

          const max = scoreMax[colNum - 1];
          if (max !== null) {
            const val = typeof cell.value === "number" ? cell.value : 0;
            cell.font = { ...bodyFont, bold: true, color: { argb: colNum === 20 ? finalColor(val) : scoreColor(val, max) } };
          }

          // grade badge color
          if (colNum === 21) {
            const gColors = { Excellent: "FF15803D", "Very Good": "FF1D4ED8", Good: "FF92400E", Average: "FFC2410C" };
            cell.font = { ...bodyFont, bold: true, color: { argb: gColors[cell.value] || "FFB91C1C" } };
          }

          // winner row left border accent on Employee column
          if (colNum === 2 && (isMonth || isWeek)) {
            cell.border = { ...border(), left: { style: "medium", color: { argb: isMonth ? "FFF59E0B" : "FFA78BFA" } } };
          }
        });
      });

      // ── Freeze top 2 rows + first 5 cols ─────────────────────────
      sheet.views = [{ state: "frozen", xSplit: 5, ySplit: 2, topLeftCell: "F3", activeCell: "F3" }];

      // ── Download ──────────────────────────────────────────────────
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const period = selectedWeek ? `${selectedMonth}_${selectedWeek}` : selectedMonth;
      link.setAttribute("download", `Evaluation_Report_${period}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);
      toast.error("Export failed");
    }
  };

  const getCurrentMonth = () => format(new Date(), "MMMM yyyy");
  const getCurrentWeek = () => {
    const now = new Date();
    const weekStart = startOfWeek(now, { weekStartsOn: 1 });
    const weekEnd = endOfWeek(now, { weekStartsOn: 1 });
    return `${format(weekStart, "dd MMM")} - ${format(weekEnd, "dd MMM")}`;
  };
  const getMonthDateValue = (monthLabel) => {
    const parsed = new Date(`${monthLabel} 01`);
    return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
  };
  const getWeekDateValue = (weekLabel, monthLabel) => {
    if (!weekLabel || !monthLabel) return 0;
    const year = monthLabel.split(" ").pop();
    const startLabel = weekLabel.split(" - ")[0];
    const parsed = new Date(`${startLabel} ${year}`);
    return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
  };

  // ================= LOAD DATA =================
  const fetchEvaluations = async (month = selectedMonth, week = selectedWeek) => {
    if (!canLoadEvaluationData) return;
    const fetchId = ++fetchIdRef.current;
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/api/evaluations`, {
        params: {
          month: month || undefined,
          week: week || undefined,
        },
        headers: { Authorization: `Bearer ${token}` }
      });

      if (fetchId === fetchIdRef.current) {
        setEvaluations(res.data);
      }
    } catch (err) {
      if (fetchId === fetchIdRef.current) {
        console.error(err);
        toast.error("Failed to load evaluations");
      }
    } finally {
      if (fetchId === fetchIdRef.current) {
        setLoading(false);
      }
    }
  };

  const fetchEmployeeOfMonth = async (month = selectedMonth) => {
    if (!canLoadEvaluationData || !month) return;
    const fetchId = ++employeeOfMonthFetchIdRef.current;
    try {
      const res = await axios.get(`${API_BASE_URL}/api/evaluations/employee-of-month`, {
        params: { month: month || undefined },
        headers: { Authorization: `Bearer ${token}` }
      });
      if (fetchId === employeeOfMonthFetchIdRef.current) {
        setEmployeeOfMonth(res.data || null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchEmployeeOfYear = async (year = selectedYear) => {
    if (!canLoadEvaluationData || !year) return;
    const fetchId = ++employeeOfYearFetchIdRef.current;
    try {
      const res = await axios.get(`${API_BASE_URL}/api/evaluations/employee-of-year`, {
        params: { year: Number(year) },
        headers: { Authorization: `Bearer ${token}` }
      });
      if (fetchId === employeeOfYearFetchIdRef.current) {
        setEmployeeOfYear(res.data || null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const loadFilterOptions = async () => {
      if (!canLoadEvaluationData) return;
      try {
        const res = await axios.get(`${API_BASE_URL}/api/evaluations/filter-options`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setFilterOptions(res.data || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load evaluation filters");
      }
    };

    setSelectedMonth(getCurrentMonth());
    setSelectedWeek(getCurrentWeek());
    setSelectedYear(format(new Date(), "yyyy"));
    loadFilterOptions();
  }, [canLoadEvaluationData, token]);

  useEffect(() => {
    if (!canLoadEvaluationData || !selectedMonth) return;
    fetchEvaluations(selectedMonth, selectedWeek);
  }, [canLoadEvaluationData, selectedMonth, selectedWeek]);

  useEffect(() => {
    if (!canLoadEvaluationData) return;
    fetchEmployeeOfMonth(selectedMonth);
  }, [canLoadEvaluationData, selectedMonth]);

  useEffect(() => {
    fetchEmployeeOfYear(selectedYear);
  }, [canLoadEvaluationData, selectedYear]);

  // ================= DELETE =================
  const openDeleteModal = (evaluation) => setDeleteTarget(evaluation);
  const closeDeleteModal = () => setDeleteTarget(null);

  const confirmDelete = async () => {
    if (!canLoadEvaluationData || !deleteTarget?.id) return;
    try {
      await axios.delete(`${API_BASE_URL}/api/evaluations/${deleteTarget.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Evaluation deleted successfully");
      closeDeleteModal();
      fetchEvaluations(selectedMonth, selectedWeek);
      fetchEmployeeOfMonth(selectedMonth);
      fetchEmployeeOfYear(selectedYear);
    } catch (err) {
      console.error(err);
      toast.error("Delete failed");
    }
  };


  const handleSubmitEvaluation = async () => {
    if (!canLoadEvaluationData || !evaluationData) return;
    try {
      const payload = {
        employeeId: evaluationData.employeeId,
        managerId: evaluationData.managerId,

        employeeType: evaluationData.employeeType,
        month: evaluationData.month,
        week: evaluationData.week,

        assignedTasks: evaluationData.assignedTasks,
        completedTasks: evaluationData.completedTasks,
        billingHours: evaluationData.billingHours,
        availableHours: evaluationData.availableHours,

        quality: evaluationData.ratings.quality,
        teamwork: evaluationData.ratings.teamwork,
        initiative: evaluationData.ratings.initiative,
        learning: evaluationData.ratings.learning,
        attendance: evaluationData.ratings.attendance,
        punctuality: evaluationData.ratings.punctuality,
        communication: evaluationData.ratings.communication,
        attitude: evaluationData.ratings.attitude,
        accountability: evaluationData.ratings.accountability,

        remarks: evaluationData.remarks
      };

      await axios.put(
        `${API_BASE_URL}/api/evaluations/${evaluationData.id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast.success("Evaluation updated successfully!");

      setShowEvaluationModal(false);
      fetchEvaluations(selectedMonth, selectedWeek);
      fetchEmployeeOfMonth(selectedMonth);
      fetchEmployeeOfYear(selectedYear);

    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || err?.response?.data || "Update failed");
    }
  };

  // ================= EDIT (modal) =================
  const handleEdit = (e) => {
    setEvaluationData({
      ...e,
      availableHours: e.availableHours || 40,
      ratings: {
        quality: e.quality,
        teamwork: e.teamwork,
        initiative: e.initiative,
        learning: e.learning,
        attendance: e.attendance,
        punctuality: e.punctuality,
        communication: e.communication,
        attitude: e.attitude,
        accountability: e.accountability,
      }
    });

    setShowEvaluationModal(true);
  };

  // ================= CELL CLICK-TO-EDIT =================
  const recomputeRow = (row) => {
    const taskScore = row.assignedTasks > 0 ? (row.completedTasks / row.assignedTasks) * 20 : 0;
    const billScore = row.availableHours > 0 ? (row.billingHours / row.availableHours) * 20 : 0;
    const total = taskScore + billScore +
      (row.quality || 0) * 2 + (row.teamwork || 0) + (row.initiative || 0) + (row.learning || 0) * 2 +
      (row.attendance || 0) * 2 + (row.punctuality || 0) + (row.communication || 0) +
      (row.attitude || 0) + (row.accountability || 0);
    const finalScore = +total.toFixed(2);
    let grade = "Poor";
    if (finalScore >= 90) grade = "Excellent";
    else if (finalScore >= 80) grade = "Very Good";
    else if (finalScore >= 70) grade = "Good";
    else if (finalScore >= 50) grade = "Average";
    return { ...row, finalScore, grade };
  };

  const openCell = (id, field, currentValue) => {
    setEditingCell({ id, field });
    setCellDraft(String(currentValue ?? ""));
  };

  const closeCell = () => {
    setEditingCell(null);
    setCellDraft("");
  };

  const commitCell = async (row, field, rawValue) => {
    closeCell();
    const numVal = Number(rawValue);
    const updatedRow = { ...row, [field]: isNaN(numVal) ? rawValue : numVal };

    const payload = {
      employeeId: updatedRow.employeeId,
      managerId: updatedRow.managerId,
      employeeType: updatedRow.employeeType,
      month: updatedRow.month,
      week: updatedRow.week,
      assignedTasks: updatedRow.assignedTasks,
      completedTasks: updatedRow.completedTasks,
      billingHours: updatedRow.billingHours,
      availableHours: updatedRow.availableHours,
      quality: updatedRow.quality,
      teamwork: updatedRow.teamwork,
      initiative: updatedRow.initiative,
      learning: updatedRow.learning,
      attendance: updatedRow.attendance,
      punctuality: updatedRow.punctuality,
      communication: updatedRow.communication,
      attitude: updatedRow.attitude,
      accountability: updatedRow.accountability,
      remarks: updatedRow.remarks,
    };

    try {
      await axios.put(`${API_BASE_URL}/api/evaluations/${row.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEvaluations(prev => prev.map(ev => ev.id === row.id ? recomputeRow(updatedRow) : ev));
      fetchEmployeeOfMonth(selectedMonth);
      fetchEmployeeOfYear(selectedYear);
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || err?.response?.data || "Update failed");
      fetchEvaluations(selectedMonth, selectedWeek);
    }
  };

  useEffect(() => {
    if (!evaluationData) return;

    const ratings = evaluationData.ratings || {};

    const assigned = evaluationData.assignedTasks || 0;
    const completed = evaluationData.completedTasks || 0;
    const taskScore = assigned > 0 ? (completed / assigned) * 20 : 0;

    const billing = evaluationData.billingHours || 0;
    const available = evaluationData.availableHours || 0;
    const billingScore = available > 0 ? (billing / available) * 20 : 0;

    const qualityScore = (ratings.quality || 0) * 2;
    const teamworkScore = (ratings.teamwork || 0) * 1;
    const initiativeScore = (ratings.initiative || 0) * 1;
    const learningScore = (ratings.learning || 0) * 2;

    const attendanceScore = (ratings.attendance || 0) * 2;
    const punctualityScore = (ratings.punctuality || 0) * 1;
    const communicationScore = (ratings.communication || 0) * 1;
    const attitudeScore = (ratings.attitude || 0) * 1;
    const accountabilityScore = (ratings.accountability || 0) * 1;

    const totalScore = taskScore + billingScore + qualityScore + teamworkScore +
      initiativeScore + learningScore + attendanceScore +
      punctualityScore + communicationScore + attitudeScore +
      accountabilityScore;

    let grade = "Poor";
    if (totalScore >= 90) grade = "Excellent";
    else if (totalScore >= 80) grade = "Very Good";
    else if (totalScore >= 70) grade = "Good";
    else if (totalScore >= 50) grade = "Average";

    setEvaluationData(prev => ({
      ...prev,
      finalScore: totalScore.toFixed(2),
      grade
    }));

  }, [
    evaluationData?.ratings,
    evaluationData?.assignedTasks,
    evaluationData?.completedTasks,
    evaluationData?.billingHours,
    evaluationData?.availableHours
  ]);

  const monthOptions = [...new Set(filterOptions.map((option) => option.month)
    .filter(Boolean)
    .filter((month) => month.includes(selectedYear)))]
    .sort((a, b) => getMonthDateValue(b) - getMonthDateValue(a));
  const yearOptions = [...new Set(
    filterOptions
      .map((option) => option.month?.trim())
      .filter(Boolean)
      .map((month) => month.match(/\b\d{4}\b/)?.[0])
      .filter(Boolean)
  )].sort((a, b) => Number(b) - Number(a));
  const weekOptions = [
    ...new Set(
      filterOptions
        .filter((option) => option.month === selectedMonth && option.week)
        .map((option) => option.week)
    ),
  ].sort((a, b) => getWeekDateValue(b, selectedMonth) - getWeekDateValue(a, selectedMonth));

  useEffect(() => {
    if (!monthOptions.length) {
      setSelectedMonth("");
      return;
    }

    if (monthOptions.includes(selectedMonth)) {
      return;
    }

    if (monthOptions.includes(getCurrentMonth())) {
      setSelectedMonth(getCurrentMonth());
      return;
    }

    setSelectedMonth(monthOptions[0]);
  }, [filterOptions, selectedYear]);

  useEffect(() => {
    const currentYear = format(new Date(), "yyyy");
    if (!yearOptions.length) {
      if (selectedYear !== currentYear) {
        setSelectedYear(currentYear);
      }
      return;
    }

    if (yearOptions.includes(selectedYear)) {
      return;
    }

    if (yearOptions.includes(currentYear)) {
      setSelectedYear(currentYear);
      return;
    }

    setSelectedYear(yearOptions[0]);
  }, [filterOptions, selectedYear]);

  useEffect(() => {
    if (!selectedMonth) return;

    const currentWeek = getCurrentWeek();
    const hasSelectedWeek = weekOptions.includes(selectedWeek);

    if (selectedWeek && hasSelectedWeek) {
      return;
    }

    if (weekOptions.includes(currentWeek)) {
      setSelectedWeek(currentWeek);
      return;
    }

    setSelectedWeek(weekOptions[0] || "");
  }, [selectedMonth, filterOptions]);

  const scoreStyle = (val, max) => {
    if (!max) return { color: "#94a3b8", fontWeight: 600 };
    const pct = val / max;
    if (pct >= 0.8) return { color: "#16a34a", fontWeight: 700 };
    if (pct >= 0.5) return { color: "#ca8a04", fontWeight: 700 };
    return { color: "#dc2626", fontWeight: 700 };
  };

  const finalScoreColor = (score) => {
    if (score >= 80) return "#16a34a";
    if (score >= 60) return "#f59e0b";
    return "#ef4444";
  };

  const positionBadge = (type) => {
    const map = {
      "Full-Time": { background: "#dbeafe", color: "#1e40af" },
      "Intern": { background: "#dcfce7", color: "#166534" },
      "Trainee": { background: "#fef9c3", color: "#854d0e" },
    };
    return map[type] || { background: "#f1f5f9", color: "#475569" };
  };

  const employeeOfMonthId = !selectedWeek ? employeeOfMonth?.highlightEvaluationId ?? null : null;
  const employeeFilterOptions = [...new Map(
    evaluations
      .map((item) => {
        const value = getPersonFilterKey(item.employeeId, item.employeeName);
        const label = item.employeeName || item.employeeId || "Unknown Employee";
        return value ? [value, { value, label }] : null;
      })
      .filter(Boolean)
  ).values()].sort((a, b) => a.label.localeCompare(b.label));
  const managerFilterOptions = [...new Map(
    evaluations
      .map((item) => {
        const value = getPersonFilterKey(item.managerId, item.managerName);
        const label = item.managerName || item.managerId || "Unknown Manager";
        return value ? [value, { value, label }] : null;
      })
      .filter(Boolean)
  ).values()].sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    if (selectedEmployeeFilter && !employeeFilterOptions.some((option) => option.value === selectedEmployeeFilter)) {
      setSelectedEmployeeFilter("");
    }
  }, [employeeFilterOptions, selectedEmployeeFilter]);

  useEffect(() => {
    if (selectedManagerFilter && !managerFilterOptions.some((option) => option.value === selectedManagerFilter)) {
      setSelectedManagerFilter("");
    }
  }, [managerFilterOptions, selectedManagerFilter]);

  const filteredEvaluations = evaluations.filter((item) => {
    const employeeKey = getPersonFilterKey(item.employeeId, item.employeeName);
    const managerKey = getPersonFilterKey(item.managerId, item.managerName);
    const employeeMatch = !selectedEmployeeFilter || employeeKey === selectedEmployeeFilter;
    const managerMatch = !selectedManagerFilter || managerKey === selectedManagerFilter;
    return employeeMatch && managerMatch;
  });

  const starOfWeekId = selectedWeek && filteredEvaluations.length
    ? filteredEvaluations.reduce((best, ev) => (ev.finalScore ?? 0) > (best.finalScore ?? 0) ? ev : best).id
    : null;
  const winnerId = employeeOfMonthId || starOfWeekId;
  const sortedEvaluations = [...filteredEvaluations].sort((a, b) => {
    const aIsWinner = a.id === winnerId;
    const bIsWinner = b.id === winnerId;
    if (aIsWinner) return -1;
    if (bIsWinner) return 1;
    return (parseFloat(b.finalScore) || 0) - (parseFloat(a.finalScore) || 0);
  });
  if (hasAccess === null) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", flexDirection: "column", gap: 12 }}>
        <div className="spinner-border text-primary" role="status" style={{ width: 36, height: 36 }} />
        <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Checking access…</div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <>
        <div className="fixed-top"><Navbar /></div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", flexDirection: "column", gap: 14, paddingTop: 80 }}>
          <div style={{ fontSize: 52 }}>🚫</div>
          <div style={{ fontWeight: 700, fontSize: "1.2rem", color: "#0f172a" }}>Access Denied</div>
          <div style={{ color: "#64748b", fontSize: "0.9rem" }}>You do not have permission to access the Employee Evaluation page.</div>
        </div>
      </>
    );
  }

  return (
    <>

      <div className="fixed-top">
        <Navbar />
      </div>

      <div style={{ paddingTop: "100px", height: "100vh", display: "flex", flexDirection: "column", background: "#f1f5f9" }}>

        <div className="card border-0" style={{ margin: "12px 16px 16px", borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 24px rgba(15,23,42,0.08)", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>

          {/* ── Card Header ── */}
          {(() => {
            const excellentCount = sortedEvaluations.filter(ev => ev.grade === "Excellent").length;
            const avgScore = sortedEvaluations.length > 0
              ? (sortedEvaluations.reduce((sum, ev) => sum + (parseFloat(ev.finalScore) || 0), 0) / sortedEvaluations.length).toFixed(1)
              : null;
            const svgArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='%2364748b' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`;
            const selectStyle = { background: "transparent", color: "#374151", border: "none", padding: "7px 28px 7px 6px", fontSize: "0.82rem", outline: "none", cursor: "pointer", appearance: "none", WebkitAppearance: "none", backgroundImage: svgArrow, backgroundRepeat: "no-repeat", backgroundPosition: "right 6px center" };
            const pillWrap = { display: "flex", alignItems: "center", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" };
            return (
              <div style={{ background: "#fff", borderBottom: "1px solid #e8edf2", padding: "16px 24px" }}>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                  {/* Left: icon + title + stats */}
                  <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <div style={{ width: 46, height: 46, borderRadius: 12, background: "linear-gradient(135deg, #3b82f6, #1d4ed8)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0, boxShadow: "0 4px 12px rgba(59,130,246,0.3)" }}>📊</div>
                    <div>
                      <div style={{ color: "#0f172a", fontWeight: 700, fontSize: "1.05rem", lineHeight: 1.2 }}>Employee Evaluations</div>
                      <div style={{ color: "#64748b", fontSize: "0.76rem", marginTop: 2 }}>{selectedMonth}</div>
                    </div>

                    {/* <div style={{ width: 1, height: 36, background: "#e2e8f0", marginLeft: 4 }} /> */}

                    {/* Live stats */}
                    {/* <div style={{ display: "flex", gap: 18, alignItems: "center" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <div style={{ color: "#0f172a", fontWeight: 800, fontSize: "1.15rem", lineHeight: 1 }}>{evaluations.length}</div>
                                                <div style={{ color: "#94a3b8", fontSize: "0.65rem", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 2 }}>Total</div>
                                            </div>
                                            <div style={{ width: 1, height: 28, background: "#e2e8f0" }} />
                                            <div style={{ textAlign: "center" }}>
                                                <div style={{ color: "#16a34a", fontWeight: 800, fontSize: "1.15rem", lineHeight: 1 }}>{excellentCount}</div>
                                                <div style={{ color: "#94a3b8", fontSize: "0.65rem", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 2 }}>Excellent</div>
                                            </div>
                                            <div style={{ width: 1, height: 28, background: "#e2e8f0" }} />
                                            <div style={{ textAlign: "center" }}>
                                                <div style={{ color: "#d97706", fontWeight: 800, fontSize: "1.15rem", lineHeight: 1 }}>{avgScore != null ? `${avgScore}%` : "—"}</div>
                                                <div style={{ color: "#94a3b8", fontSize: "0.65rem", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 2 }}>Avg Score</div>
                                            </div>
                                        </div> */}
                  </div>

                  {/* Right: emoji-prefixed selects + export */}
                  <div className="d-flex gap-2 align-items-center flex-wrap">

                    <div style={pillWrap}>
                      <span style={{ fontSize: 13, userSelect: "none", flexShrink: 0 }}>📅</span>
                      <select style={{ ...selectStyle, width: 90 }} value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                        {(yearOptions.length ? yearOptions : [format(new Date(), "yyyy")]).map((year, i) => (
                          <option key={i} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>
                    <div style={pillWrap}>
                      <span style={{ fontSize: 13, userSelect: "none", flexShrink: 0 }}>📅</span>
                      <select style={{ ...selectStyle, width: 155 }} value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                        {monthOptions.length ? monthOptions.map((month, i) => (
                          <option key={i} value={month}>{month}</option>
                        )) : (
                          <option value="">No Months</option>
                        )}
                      </select>
                    </div>
                    <div style={pillWrap}>
                      <span style={{ fontSize: 13, userSelect: "none", flexShrink: 0 }}>📆</span>
                      <select style={{ ...selectStyle, width: 190 }} value={selectedWeek} onChange={(e) => setSelectedWeek(e.target.value)}>
                        <option value="">All Weeks</option>
                        {weekOptions.map((week, i) => (
                          <option key={i} value={week}>{week}</option>
                        ))}
                      </select>
                    </div>
                    <div style={pillWrap}>
                      <select style={{ ...selectStyle, width: 160 }} value={selectedEmployeeFilter} onChange={(e) => { setSelectedEmployeeFilter(e.target.value); setSelectedManagerFilter(""); }}>
                        <option value="">All Employees</option>
                        {employeeFilterOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                    <div style={pillWrap}>
                      <select style={{ ...selectStyle, width: 150 }} value={selectedManagerFilter} onChange={(e) => { setSelectedManagerFilter(e.target.value); setSelectedEmployeeFilter(""); }}>
                        <option value="">All Managers</option>
                        {managerFilterOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>

                    <button
                      onClick={handleExportExcel}
                      style={{ display: "flex", alignItems: "center", gap: 6, padding: "7px 14px", borderRadius: 10, border: "none", background: "#16a34a", color: "#fff", fontWeight: 700, fontSize: "0.8rem", whiteSpace: "nowrap", cursor: "pointer", boxShadow: "0 2px 8px rgba(22,163,74,0.25)", flexShrink: 0 }}
                      onMouseEnter={e => e.currentTarget.style.opacity = "0.88"}
                      onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                      Export Excel
                    </button>
                  </div>

                </div>
              </div>
            );
          })()}


          {/* ── Employee of the Year Banner ── */}
          {employeeOfYear && (
            <div style={{
              background:
                "linear-gradient(135deg, #1f2937 0%, #991b1b 50%, #ef4444 100%)", padding: "10px 24px", display: "flex", alignItems: "center", gap: 14, flexShrink: 0, flexWrap: "wrap"
            }}>
              <div style={{ fontSize: 28, lineHeight: 1 }}>🥇</div>
              <div style={{ flex: 1 }}>
                <div style={{ color: "#fef3c7", fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 2 }}>
                  Employee of the Year {selectedYear}
                </div>
                <div style={{ color: "#fff", fontSize: "0.92rem", fontWeight: 800, lineHeight: 1.2 }}>
                  {employeeOfYear.employeeName}
                </div>
              </div>
              {/* <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                <span style={{ color: "#fef3c7", fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>Year</span>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  style={{
                    background: "rgba(255,255,255,0.14)",
                    color: "#fff",
                    border: "1px solid rgba(255,255,255,0.24)",
                    borderRadius: 10,
                    padding: "6px 28px 6px 10px",
                    fontSize: "0.8rem",
                    fontWeight: 700,
                    outline: "none",
                    cursor: "pointer",
                    appearance: "none",
                    WebkitAppearance: "none",
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='%23ffffff' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 10px center",
                    minWidth: 90,
                  }}
                >
                  {(yearOptions.length ? yearOptions : [format(new Date(), "yyyy")]).map((year) => (
                    <option key={year} value={year} style={{ color: "#0f172a" }}>
                      {year}
                    </option>
                  ))}
                </select>
              </div> */}
              <div style={{ textAlign: "right", flexShrink: 0 }}>
                <div style={{ color: "#fef3c7", fontSize: "0.65rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>Yearly Avg</div>
                <div style={{ color: "#fff", fontSize: "1.1rem", fontWeight: 900, lineHeight: 1 }}>{employeeOfYear.averageScore}%</div>
              </div>
            </div>
          )}

          {/* ── Card Body ── */}
          <div style={{ padding: 0, flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            {loading ? (
              <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <div className="spinner-border text-primary" role="status" style={{ width: 40, height: 40 }} />
                <div style={{ marginTop: 14, color: "#64748b", fontSize: "0.9rem", fontWeight: 500 }}>Loading evaluations…</div>
              </div>
            ) : (
              <div style={{ flex: 1, minHeight: 0, overflowX: "auto", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, fontSize: "0.83rem", whiteSpace: "nowrap" }}>

                  {/* ── THEAD ── */}
                  <thead style={{ position: "sticky", top: 0, zIndex: 4 }}>
                    <tr>
                      {/* Frozen corner — sticky left + inherits top from thead */}
                      <th rowSpan="2" style={{ position: "sticky", left: 0, zIndex: 6, background: "#f8fafc", color: "#475569", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.06em", padding: "14px 10px", textAlign: "center", borderBottom: "2px solid #e2e8f0", borderRight: "1px solid #e2e8f0", minWidth: 54 }}>Sr.no</th>
                      <th rowSpan="2" style={{ position: "sticky", left: 54, zIndex: 6, background: "#f8fafc", color: "#475569", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.06em", padding: "14px 14px", textAlign: "left", borderBottom: "2px solid #e2e8f0", borderRight: "1px solid #e2e8f0", minWidth: 160 }}>Employee</th>
                      <th rowSpan="2" style={{ position: "sticky", left: 214, zIndex: 6, background: "#f8fafc", color: "#475569", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.06em", padding: "14px 14px", textAlign: "left", borderBottom: "2px solid #e2e8f0", borderRight: "1px solid #e2e8f0", minWidth: 150 }}>Reporter</th>
                      <th rowSpan="2" style={{ position: "sticky", left: 364, zIndex: 6, background: "#f8fafc", color: "#475569", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.06em", padding: "14px 10px", textAlign: "center", borderBottom: "2px solid #e2e8f0", borderRight: "1px solid #e2e8f0", minWidth: 110 }}>Position</th>
                      <th rowSpan="2" style={{ position: "sticky", left: 474, zIndex: 6, background: "#f8fafc", color: "#475569", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.06em", padding: "14px 12px", textAlign: "center", borderBottom: "2px solid #e2e8f0", boxShadow: "4px 0 8px rgba(0,0,0,0.06)", minWidth: 150 }}>Period</th>
                      {/* Work Performance group */}
                      <th colSpan="9" style={{ background: "#eff6ff", color: "#1d4ed8", textAlign: "center", fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.07em", padding: "10px 14px", borderLeft: "2px solid #bfdbfe", borderBottom: "1px solid #bfdbfe" }}>⚡ Work Performance</th>
                      {/* Professionalism group */}
                      <th colSpan="5" style={{ background: "#f5f3ff", color: "#5b21b6", textAlign: "center", fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.07em", padding: "10px 14px", borderLeft: "2px solid #ddd6fe", borderBottom: "1px solid #ddd6fe" }}>🤝 Professionalism</th>
                      {/* Summary */}
                      <th rowSpan="2" style={{ background: "#f0fdf4", color: "#065f46", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", padding: "14px 12px", textAlign: "center", borderLeft: "2px solid #bbf7d0", borderBottom: "2px solid #bbf7d0", minWidth: 110 }}>Score</th>
                      <th rowSpan="2" style={{ background: "#f0fdf4", color: "#065f46", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", padding: "14px 12px", textAlign: "center", borderLeft: "1px solid #bbf7d0", borderBottom: "2px solid #bbf7d0", minWidth: 95 }}>Grade</th>
                      <th rowSpan="2" style={{ background: "#f0fdf4", color: "#065f46", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", padding: "14px 12px", textAlign: "center", borderLeft: "1px solid #bbf7d0", borderBottom: "2px solid #bbf7d0", minWidth: 130 }}>Remarks</th>
                      <th rowSpan="2" style={{ background: "#f0fdf4", color: "#065f46", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", padding: "14px 12px", textAlign: "center", borderLeft: "1px solid #bbf7d0", borderBottom: "2px solid #bbf7d0", minWidth: 90 }}>Actions</th>
                    </tr>
                    <tr>
                      {/* Work Performance sub-headers */}
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderLeft: "2px solid #bfdbfe", borderBottom: "2px solid #bfdbfe" }}>C / A</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Task /20</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Quality /10</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Teamwork /5</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Initiative /5</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Learning /10</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Bill Hrs</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Avail Hrs</th>
                      <th style={{ background: "#dbeafe", color: "#1e40af", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #bfdbfe" }}>Bill /20</th>
                      {/* Professionalism sub-headers */}
                      <th style={{ background: "#ede9fe", color: "#5b21b6", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderLeft: "2px solid #ddd6fe", borderBottom: "2px solid #ddd6fe" }}>Attend /10</th>
                      <th style={{ background: "#ede9fe", color: "#5b21b6", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #ddd6fe" }}>Punct /5</th>
                      <th style={{ background: "#ede9fe", color: "#5b21b6", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #ddd6fe" }}>Comm /5</th>
                      <th style={{ background: "#ede9fe", color: "#5b21b6", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #ddd6fe" }}>Attitude /5</th>
                      <th style={{ background: "#ede9fe", color: "#5b21b6", fontWeight: 600, fontSize: "0.69rem", padding: "8px 10px", textAlign: "center", borderBottom: "2px solid #ddd6fe" }}>Account /5</th>
                    </tr>
                  </thead>

                  {/* ── TBODY ── */}
                  <tbody>
                    {evaluations.length ? (
                      sortedEvaluations.map((e, index) => {
                        const isEven = index % 2 === 0;
                        const isMonth = e.id === employeeOfMonthId;
                        const isWeek = e.id === starOfWeekId;
                        const rowBg = hoveredRow === index ? "#eff6ff" : isMonth ? "#fffbeb" : isWeek ? "#faf5ff" : isEven ? "#ffffff" : "#f8faff";
                        const posBadge = positionBadge(e.employeeType);
                        const fColor = finalScoreColor(e.finalScore);
                        const taskScore = e.assignedTasks > 0 ? (e.completedTasks / e.assignedTasks) * 20 : 0;
                        const billScore = e.availableHours > 0 ? (e.billingHours / e.availableHours) * 20 : 0;

                        const isCell = (field) => editingCell?.id === e.id && editingCell?.field === field;
                        const inputStyle = { width: 52, textAlign: "center", border: "2px solid #3b82f6", borderRadius: 6, padding: "3px 4px", fontSize: "0.8rem", outline: "none", background: "#fff", fontWeight: 600, boxShadow: "0 0 0 3px rgba(59,130,246,0.12)" };
                        const spanStyle = { cursor: "text", display: "inline-block", padding: "2px 5px", borderRadius: 4, borderBottom: "1px dashed #cbd5e1", transition: "background 0.12s" };

                        const EditableNum = ({ field, value, min = 0, max, display, multiplier }) => isCell(field) ? (
                          <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                            <input
                              type="number" min={min} max={max}
                              style={inputStyle}
                              value={cellDraft}
                              autoFocus
                              onChange={ev => setCellDraft(ev.target.value)}
                              onBlur={() => commitCell(e, field, cellDraft)}
                              onKeyDown={ev => { if (ev.key === "Enter") commitCell(e, field, cellDraft); if (ev.key === "Escape") closeCell(); }}
                            />
                            {multiplier && (
                              <span style={{ fontSize: "0.62rem", color: "#3b82f6", fontWeight: 700, background: "#eff6ff", borderRadius: 4, padding: "1px 5px", whiteSpace: "nowrap" }}>
                                ×{multiplier} = {((+cellDraft || 0) * multiplier).toFixed(0)}
                              </span>
                            )}
                          </div>
                        ) : (
                          <span
                            style={spanStyle}
                            title="Click to edit"
                            onMouseEnter={ev => ev.currentTarget.style.background = "#dbeafe"}
                            onMouseLeave={ev => ev.currentTarget.style.background = "transparent"}
                            onClick={() => openCell(e.id, field, value)}
                          >
                            {display ?? value}
                          </span>
                        );

                        return (
                          <tr
                            key={e.id}
                            onMouseEnter={() => setHoveredRow(index)}
                            onMouseLeave={() => setHoveredRow(null)}
                            style={{ background: rowBg }}
                          >
                            {/* Frozen: # */}
                            <td style={{ position: "sticky", left: 0, zIndex: 2, background: rowBg, textAlign: "center", padding: "12px 10px", borderRight: "1px solid #e2e8f0", borderBottom: "1px solid #f1f5f9", color: "#94a3b8", fontWeight: 700, fontSize: "0.78rem" }}>{index + 1}</td>

                            {/* Frozen: Employee */}
                            <td style={{ position: "sticky", left: 54, zIndex: 2, background: rowBg, padding: "10px 14px", borderRight: "1px solid #e2e8f0", borderBottom: "1px solid #f1f5f9", borderLeft: isMonth ? "3px solid #f59e0b" : isWeek ? "3px solid #a78bfa" : "3px solid transparent" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                                <div style={{ position: "relative", flexShrink: 0 }}>
                                  <div style={{ width: 30, height: 30, borderRadius: "50%", background: isMonth ? "linear-gradient(135deg,#f59e0b,#d97706)" : isWeek ? "linear-gradient(135deg,#7c3aed,#5b21b6)" : "linear-gradient(135deg,#3b82f6,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, color: "#fff" }}>{getInitials(e.employeeName || String(e.employeeId || ""))}</div>
                                  {(isMonth || isWeek) && (
                                    <span style={{ position: "absolute", bottom: -2, right: -4, fontSize: 11, lineHeight: 1 }}>{isMonth ? "🏆" : "⭐"}</span>
                                  )}
                                </div>
                                <div>
                                  <span style={{ fontWeight: 600, color: "#0f172a", fontSize: "0.83rem" }}>{e.employeeName || e.employeeId}</span>
                                  {isMonth && <div style={{ fontSize: "0.62rem", fontWeight: 700, color: "#b45309", marginTop: 1 }}>Employee of the Month</div>}
                                  {isWeek && !isMonth && <div style={{ fontSize: "0.62rem", fontWeight: 700, color: "#7c3aed", marginTop: 1 }}>Star of the Week</div>}
                                </div>
                              </div>
                            </td>

                            {/* Frozen: Reporter */}
                            <td style={{ position: "sticky", left: 214, zIndex: 2, background: rowBg, padding: "10px 14px", borderRight: "1px solid #e2e8f0", borderBottom: "1px solid #f1f5f9" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                                <div style={{ width: 30, height: 30, borderRadius: "50%", background: "linear-gradient(135deg,#f59e0b,#ef4444)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, color: "#fff", flexShrink: 0 }}>{getInitials(e.managerName || String(e.managerId || ""))}</div>
                                <span style={{ fontWeight: 500, color: "#334155", fontSize: "0.83rem" }}>{e.managerName || e.managerId}</span>
                              </div>
                            </td>

                            {/* Frozen: Position */}
                            <td style={{ position: "sticky", left: 364, zIndex: 2, background: rowBg, padding: "10px 10px", textAlign: "center", borderRight: "1px solid #e2e8f0", borderBottom: "1px solid #f1f5f9" }}>
                              <span style={{ ...posBadge, padding: "3px 10px", borderRadius: 999, fontSize: "0.72rem", fontWeight: 600 }}>{e.employeeType || "—"}</span>
                            </td>

                            {/* Frozen: Period */}
                            <td style={{ position: "sticky", left: 474, zIndex: 2, background: rowBg, padding: "10px 12px", textAlign: "center", borderBottom: "1px solid #f1f5f9", boxShadow: "4px 0 8px rgba(0,0,0,0.07)" }}>
                              <div style={{ fontWeight: 600, color: "#0f172a", fontSize: "0.8rem" }}>{e.month}</div>
                              <div style={{ color: "#64748b", fontSize: "0.71rem", marginTop: 2 }}>{e.week}</div>
                            </td>

                            {/* ── Work Performance ── */}
                            {/* C / A — two separately clickable numbers */}
                            <td style={{ textAlign: "center", padding: "12px 8px", borderLeft: "2px solid #dbeafe", borderBottom: "1px solid #f1f5f9", color: "#1d4ed8", fontWeight: 700 }}>
                              <EditableNum field="completedTasks" value={e.completedTasks || 0} min={0} />
                              <span style={{ color: "#94a3b8", margin: "0 2px" }}>/</span>
                              <EditableNum field="assignedTasks" value={e.assignedTasks || 0} min={0} />
                            </td>
                            {/* Task /20 — computed, read-only */}
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(taskScore, 20) }}>{taskScore.toFixed(1)}</td>
                            {/* Quality /10 — rating 1-5, shows ×2 */}
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle((e.quality || 0) * 2, 10) }}>
                              <EditableNum field="quality" value={e.quality || 0} min={0} max={5} display={(e.quality || 0) * 2} multiplier={2} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(e.teamwork || 0, 5) }}>
                              <EditableNum field="teamwork" value={e.teamwork || 0} min={0} max={5} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(e.initiative || 0, 5) }}>
                              <EditableNum field="initiative" value={e.initiative || 0} min={0} max={5} />
                            </td>
                            {/* Learning /10 — rating 1-5, shows ×2 */}
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle((e.learning || 0) * 2, 10) }}>
                              <EditableNum field="learning" value={e.learning || 0} min={0} max={5} display={(e.learning || 0) * 2} multiplier={2} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", color: "#475569", fontWeight: 500 }}>
                              <EditableNum field="billingHours" value={e.billingHours ?? 0} min={0} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", color: "#475569", fontWeight: 500 }}>
                              <EditableNum field="availableHours" value={e.availableHours ?? 0} min={0} />
                            </td>
                            {/* Bill /20 — computed, read-only */}
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(billScore, 20) }}>{billScore.toFixed(1)}</td>

                            {/* ── Professionalism ── */}
                            {/* Attendance /10 — rating 1-5, shows ×2 */}
                            <td style={{ textAlign: "center", padding: "12px 10px", borderLeft: "2px solid #ede9fe", borderBottom: "1px solid #f1f5f9", ...scoreStyle((e.attendance || 0) * 2, 10) }}>
                              <EditableNum field="attendance" value={e.attendance || 0} min={0} max={5} display={(e.attendance || 0) * 2} multiplier={2} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(e.punctuality || 0, 5) }}>
                              <EditableNum field="punctuality" value={e.punctuality || 0} min={0} max={5} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(e.communication || 0, 5) }}>
                              <EditableNum field="communication" value={e.communication || 0} min={0} max={5} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(e.attitude || 0, 5) }}>
                              <EditableNum field="attitude" value={e.attitude || 0} min={0} max={5} />
                            </td>
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9", ...scoreStyle(e.accountability || 0, 5) }}>
                              <EditableNum field="accountability" value={e.accountability || 0} min={0} max={5} />
                            </td>

                            {/* Total Score — read-only (server computed) */}
                            <td style={{ textAlign: "center", padding: "10px 12px", borderLeft: "2px solid #ccfbf1", borderBottom: "1px solid #f1f5f9" }}>
                              <div style={{ fontWeight: 800, fontSize: "0.95rem", color: fColor }}>{e.finalScore}%</div>
                              <div style={{ width: 60, height: 4, background: "#e2e8f0", borderRadius: 999, overflow: "hidden", margin: "5px auto 0" }}>
                                <div style={{ width: `${Math.min(e.finalScore || 0, 100)}%`, height: "100%", background: fColor, borderRadius: 999 }} />
                              </div>
                            </td>

                            {/* Grade — read-only */}
                            <td style={{ textAlign: "center", padding: "12px 10px", borderBottom: "1px solid #f1f5f9" }}>
                              {(() => {
                                const gMap = {
                                  "Excellent": { bg: "#dcfce7", color: "#15803d", dot: "#22c55e" },
                                  "Very Good": { bg: "#dbeafe", color: "#1d4ed8", dot: "#3b82f6" },
                                  "Good": { bg: "#fef9c3", color: "#92400e", dot: "#f59e0b" },
                                  "Average": { bg: "#ffedd5", color: "#c2410c", dot: "#fb923c" },
                                };
                                const gm = gMap[e.grade] || { bg: "#fee2e2", color: "#b91c1c", dot: "#ef4444" };
                                return (
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 11px 4px 8px", borderRadius: 999, fontSize: "0.72rem", fontWeight: 700, background: gm.bg, color: gm.color }}>
                                    <span style={{ width: 6, height: 6, borderRadius: "50%", background: gm.dot, flexShrink: 0 }} />
                                    {e.grade || "—"}
                                  </span>
                                );
                              })()}
                            </td>

                            {/* Remarks — click to edit */}
                            <td style={{ padding: "12px 10px", borderBottom: "1px solid #f1f5f9" }}>
                              {isCell("remarks") ? (
                                <input
                                  style={{ width: 110, border: "2px solid #3b82f6", borderRadius: 6, padding: "3px 6px", fontSize: "0.78rem", outline: "none", background: "#fff", boxShadow: "0 0 0 3px rgba(59,130,246,0.12)" }}
                                  value={cellDraft}
                                  autoFocus
                                  onChange={ev => setCellDraft(ev.target.value)}
                                  onBlur={() => commitCell(e, "remarks", cellDraft)}
                                  onKeyDown={ev => { if (ev.key === "Enter") commitCell(e, "remarks", cellDraft); if (ev.key === "Escape") closeCell(); }}
                                  placeholder="Add remark…"
                                />
                              ) : (
                                <span
                                  style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 120, color: e.remarks ? "#64748b" : "#cbd5e1", fontSize: "0.8rem", fontStyle: "italic", cursor: "text", borderBottom: "1px dashed #cbd5e1" }}
                                  title={e.remarks || "Click to add remark"}
                                  onClick={() => openCell(e.id, "remarks", e.remarks || "")}
                                  onMouseEnter={ev => ev.currentTarget.style.background = "#dbeafe"}
                                  onMouseLeave={ev => ev.currentTarget.style.background = "transparent"}
                                >
                                  {e.remarks || "—"}
                                </span>
                              )}
                            </td>

                            {/* Actions */}
                            <td style={{ textAlign: "center", padding: "10px 12px", borderBottom: "1px solid #f1f5f9" }}>
                              <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                                <button
                                  onClick={() => handleEdit(e)}
                                  title="Edit"
                                  style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #bfdbfe", background: "#eff6ff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#2563eb", transition: "all 0.15s" }}
                                  onMouseEnter={(ev) => { ev.currentTarget.style.background = "#dbeafe"; ev.currentTarget.style.borderColor = "#93c5fd"; }}
                                  onMouseLeave={(ev) => { ev.currentTarget.style.background = "#eff6ff"; ev.currentTarget.style.borderColor = "#bfdbfe"; }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => openDeleteModal(e)}
                                  title="Delete"
                                  style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #fecaca", background: "#fff1f2", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626", transition: "all 0.15s" }}
                                  onMouseEnter={(ev) => { ev.currentTarget.style.background = "#fee2e2"; ev.currentTarget.style.borderColor = "#f87171"; }}
                                  onMouseLeave={(ev) => { ev.currentTarget.style.background = "#fff1f2"; ev.currentTarget.style.borderColor = "#fecaca"; }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="3 6 5 6 21 6" />
                                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                    <path d="M10 11v6M14 11v6" />
                                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="23" style={{ padding: "70px 20px", textAlign: "center" }}>
                          <div style={{ fontSize: 52, marginBottom: 14, opacity: 0.35 }}>📋</div>
                          <div style={{ fontWeight: 600, color: "#334155", fontSize: "1rem", marginBottom: 6 }}>No evaluations found</div>
                          <div style={{ color: "#94a3b8", fontSize: "0.85rem" }}>Try adjusting the month, week, employee, or manager filters</div>
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            )}
          </div>

        </div>

      </div>

      {showEvaluationModal && evaluationData && (() => {
        const { ratings = {}, finalScore = 0, grade = "-" } = evaluationData;
        const completionPct =
          evaluationData.assignedTasks > 0
            ? Math.round((evaluationData.completedTasks / evaluationData.assignedTasks) * 100)
            : 0;
        const gradeMeta = getGradeMeta(grade);

        return (
          <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && setShowEvaluationModal(false)}>
            <div style={styles.modal} role="dialog" aria-modal="true">

              {/* Header */}
              <div style={styles.header}>
                <div style={styles.headerLeft}>
                  <div style={styles.headerIconWrap}>📋</div>
                  <div>
                    <div style={styles.headerTitle}>Employee Evaluation</div>
                    <div style={styles.headerSub}>
                      {evaluationData.month}
                      {evaluationData.week ? ` · ${evaluationData.week}` : ""}
                    </div>
                  </div>
                </div>
                <button style={styles.closeBtn} onClick={() => setShowEvaluationModal(false)} aria-label="Close">✕</button>
              </div>

              {/* Body */}
              <div style={styles.body}>

                {/* Row 1: Personnel + Work Summary */}
                <div style={styles.twoCol}>
                  {/* Personnel */}
                  <div style={styles.card}>
                    <div style={styles.sectionLabel}>👤 Personnel</div>
                    <div style={styles.fieldGroup}>
                      <div style={styles.fieldRow}>
                        <div style={styles.fieldLabel}>Manager</div>
                        <div style={styles.readonlyField}>
                          <div style={{ ...styles.avatarCircle, background: "linear-gradient(135deg,#f59e0b,#ef4444)" }}>
                            {getInitials(evaluationData.managerName || evaluationData.managerId || "")}
                          </div>
                          {evaluationData.managerName || evaluationData.managerId || "—"}
                        </div>
                      </div>

                      <div style={styles.fieldRow}>
                        <div style={styles.fieldLabel}>Employee</div>
                        <div style={styles.readonlyField}>
                          <div style={styles.avatarCircle}>
                            {getInitials(evaluationData.employeeName || evaluationData.employeeId || "")}
                          </div>
                          {evaluationData.employeeName || evaluationData.employeeId || "—"}
                        </div>
                      </div>

                      <div style={styles.fieldRow}>
                        <div style={styles.fieldLabel}>Position</div>
                        <div style={{ ...styles.readonlyField, justifyContent: "space-between" }}>
                          <span>{evaluationData.employeeType || "—"}</span>
                          {/* {evaluationData.employeeType && (
                                  <span style={{ ...positionBadge(evaluationData.employeeType), padding: "2px 10px", borderRadius: 999, fontSize: "0.72rem", fontWeight: 600 }}>
                                    {evaluationData.employeeType}
                                  </span>
                                )} */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Work Summary */}
                  <div style={styles.card}>
                    <div style={styles.sectionLabel}>📊 Work Summary</div>
                    <div style={styles.statsGrid}>
                      <div style={styles.statCell}>
                        <div style={styles.statLabel}>Month</div>
                        <input
                          style={styles.statInput}
                          value={evaluationData.month || ""}
                          onChange={(e) => setEvaluationData(prev => ({ ...prev, month: e.target.value }))}
                        />
                      </div>
                      <div style={styles.statCell}>
                        <div style={styles.statLabel}>Week</div>
                        <input
                          style={styles.statInput}
                          value={evaluationData.week || ""}
                          onChange={(e) => setEvaluationData(prev => ({ ...prev, week: e.target.value }))}
                        />
                      </div>
                      <div style={styles.statCell}>
                        <div style={styles.statLabel}>Assigned</div>
                        <input
                          type="number"
                          style={styles.statInput}
                          value={evaluationData.assignedTasks || 0}
                          onChange={(e) => setEvaluationData(prev => ({ ...prev, assignedTasks: Number(e.target.value) }))}
                        />
                      </div>
                      <div style={styles.statCell}>
                        <div style={styles.statLabel}>Completed</div>
                        <div style={{ ...styles.statVal, display: "flex", gap: "6px" }}>
                          <input
                            type="number"
                            style={{ ...styles.statInput, width: "30px" }}
                            value={evaluationData.completedTasks || 0}
                            onChange={(e) => setEvaluationData(prev => ({ ...prev, completedTasks: Number(e.target.value) }))}
                          />
                          {completionPct > 0 && (
                            <span style={styles.completedBadge}>✓ {completionPct}%</span>
                          )}
                        </div>
                      </div>
                      <div style={styles.statCell}>
                        <div style={styles.statLabel}>Billing Hours</div>
                        <input
                          type="number"
                          style={styles.statInput}
                          value={evaluationData.billingHours || 0}
                          onChange={(e) => setEvaluationData(prev => ({ ...prev, billingHours: Number(e.target.value) }))}
                        />
                      </div>
                      <div style={styles.statCell}>
                        <div style={styles.statLabel}>Available Hours</div>
                        <input
                          type="number"
                          style={styles.statInput}
                          value={evaluationData.availableHours || 0}
                          onChange={(e) => setEvaluationData(prev => ({ ...prev, availableHours: Number(e.target.value) }))}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Row 2: Ratings */}
                <div style={styles.twoCol}>
                  <div style={styles.ratingsCard}>
                    <div style={styles.sectionLabel}>⭐ Work Performance</div>
                    {workPerformanceRatings.map((item, idx) => (
                      <div key={item.key} style={{ ...styles.ratingRow, marginBottom: idx === workPerformanceRatings.length - 1 ? 0 : "8px" }}>
                        <div style={styles.ratingLabel}>
                          <div style={styles.ratingIcon}>{item.icon}</div>
                          {item.label}
                        </div>
                        <StarRating
                          value={ratings[item.key] || 0}
                          onChange={(val) =>
                            setEvaluationData((prev) => ({
                              ...prev,
                              ratings: { ...(prev.ratings || {}), [item.key]: val },
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div style={styles.ratingsCard}>
                    <div style={styles.sectionLabel}>🤝 Professionalism</div>
                    {professionalismRatings.map((item, idx) => (
                      <div key={item.key} style={{ ...styles.ratingRow, marginBottom: idx === professionalismRatings.length - 1 ? 0 : "8px" }}>
                        <div style={styles.ratingLabel}>
                          <div style={styles.ratingIcon}>{item.icon}</div>
                          {item.label}
                        </div>
                        <StarRating
                          value={ratings[item.key] || 0}
                          onChange={(val) =>
                            setEvaluationData((prev) => ({
                              ...prev,
                              ratings: { ...(prev.ratings || {}), [item.key]: val },
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Row 3: Score */}
                <div style={styles.scoreCard}>
                  <ScoreRing score={finalScore} ringColor={gradeMeta.ringColor} />

                  <div style={styles.scoreRight}>
                    <div
                      style={{
                        ...styles.gradeBadge,
                        background: gradeMeta.bg,
                        color: gradeMeta.color,
                      }}
                    >
                      🏅 Grade {grade}
                    </div>
                    <div style={styles.progressTrack}>
                      <div
                        style={{
                          ...styles.progressFill,
                          width: `${(finalScore / 100) * 100}%`,
                          background: gradeMeta.barColor,
                        }}
                      />
                    </div>
                    <div style={styles.progressLabels}>
                      <span style={styles.progressLabel}>0</span>
                      <span style={styles.progressLabel}>Overall performance</span>
                      <span style={styles.progressLabel}>100</span>
                    </div>
                  </div>
                </div>

                {/* Row 4: Remarks */}
                <div style={styles.remarksCard}>
                  <div style={styles.sectionLabel}>💬 Remarks</div>
                  <textarea
                    style={styles.textarea}
                    rows={3}
                    placeholder="Add feedback or comments for this evaluation period…"
                    value={evaluationData.remarks || ""}
                    onChange={(e) =>
                      setEvaluationData((prev) => ({ ...prev, remarks: e.target.value }))
                    }
                    onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>
              </div>

              {/* Footer */}
              <div style={styles.footer}>
                <div style={styles.footerNote}></div>
                <div style={styles.btnGroup}>
                  <button
                    style={styles.btnPrimary}
                    onClick={handleSubmitEvaluation}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    Save
                  </button>
                  <button
                    style={styles.btnGhost}
                    onClick={() => setShowEvaluationModal(false)}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    Cancel
                  </button>

                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Delete Confirmation Modal ── */}
      {deleteTarget && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: 16 }}
          onClick={(ev) => ev.target === ev.currentTarget && closeDeleteModal()}
        >
          <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 420, boxShadow: "0 24px 64px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)", overflow: "hidden" }}>

            {/* Header */}
            <div style={{ padding: "22px 26px 18px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{ width: 46, height: 46, borderRadius: 13, background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6M14 11v6" />
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                </svg>
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: "1rem", color: "#0f172a" }}>Delete Evaluation</div>
                <div style={{ fontSize: "0.78rem", color: "#94a3b8", marginTop: 2 }}>This action cannot be undone</div>
              </div>
              <button
                onClick={closeDeleteModal}
                style={{ marginLeft: "auto", width: 32, height: 32, borderRadius: 9, border: "1px solid #e2e8f0", background: "transparent", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b", fontSize: 15 }}
                onMouseEnter={ev => ev.currentTarget.style.background = "#f8fafc"}
                onMouseLeave={ev => ev.currentTarget.style.background = "transparent"}
              >✕</button>
            </div>

            {/* Body */}
            <div style={{ padding: "20px 26px" }}>
              <p style={{ color: "#475569", fontSize: "0.88rem", marginBottom: 16, lineHeight: 1.65 }}>
                Are you sure you want to delete the evaluation for{" "}
                <strong style={{ color: "#0f172a" }}>{deleteTarget.employeeName || deleteTarget.employeeId}</strong>?
              </p>

              {/* Info card */}
              <div style={{ background: "#f8fafc", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px", display: "flex", gap: 0 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>Employee</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#3b82f6,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
                      {getInitials(deleteTarget.employeeName || String(deleteTarget.employeeId || ""))}
                    </div>
                    <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#0f172a" }}>{deleteTarget.employeeName || deleteTarget.employeeId}</span>
                  </div>
                </div>
                <div style={{ width: 1, background: "#e2e8f0", margin: "0 16px" }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>Period</div>
                  <div style={{ fontSize: "0.85rem", fontWeight: 600, color: "#0f172a" }}>{deleteTarget.month}</div>
                  {deleteTarget.week && <div style={{ fontSize: "0.76rem", color: "#64748b", marginTop: 1 }}>{deleteTarget.week}</div>}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div style={{ padding: "16px 26px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button
                onClick={closeDeleteModal}
                style={{ padding: "9px 22px", borderRadius: 10, border: "1px solid #e2e8f0", background: "transparent", fontSize: "0.85rem", fontWeight: 600, color: "#64748b", cursor: "pointer", transition: "all 0.15s" }}
                onMouseEnter={ev => ev.currentTarget.style.background = "#f8fafc"}
                onMouseLeave={ev => ev.currentTarget.style.background = "transparent"}
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                style={{ padding: "9px 22px", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#ef4444,#dc2626)", fontSize: "0.85rem", fontWeight: 700, color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: 7, boxShadow: "0 4px 14px rgba(220,38,38,0.3)", transition: "opacity 0.15s" }}
                onMouseEnter={ev => ev.currentTarget.style.opacity = "0.88"}
                onMouseLeave={ev => ev.currentTarget.style.opacity = "1"}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6M14 11v6" />
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                </svg>
                Yes, Delete
              </button>
            </div>

          </div>
        </div>
      )}

    </>
  );
};

export default EmployeeEvaluation;
